import React from "react";
import PropTypes from 'prop-types';
import {SvgIcon, Typography, withStyles} from "@material-ui/core";
import {pink} from "@material-ui/core/colors";

const styles = (theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center'
  },
  incentiveContainer: {
    display: 'inline-flex',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  rowContent: {
    display: 'flex',
    padding: 4,
    alignItems: 'center'
  },
  firstRow: {
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    borderLeftWidth: 1,
    borderTopWidth: 1,
    borderRightWidth: 1,
    borderBottomWidth: 0,
    borderLeftStyle: 'solid',
    borderRightStyle: 'solid',
    borderTopStyle: 'solid',
    borderColor: pink[500]
  },
  firstRowActive: {
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    borderLeftWidth: 1,
    borderTopWidth: 1,
    borderRightWidth: 1,
    borderBottomWidth: 0,
    borderLeftStyle: 'solid',
    borderRightStyle: 'solid',
    borderTopStyle: 'solid',
    backgroundColor: pink[500],
    borderColor: pink[500]
  },
  row: {
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderTopWidth: 1,
    borderLeftStyle: 'solid',
    borderRightStyle: 'solid',
    borderTopStyle: 'solid',
    borderColor: pink[500]
  },
  rowActive: {
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderTopWidth: 1,
    borderLeftStyle: 'solid',
    borderRightStyle: 'solid',
    borderTopStyle: 'solid',
    backgroundColor: pink[500],
    borderColor: pink[500]
  },
  rowSingle: {
    borderRadius: 4,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: pink[500]
  },
  rowSingleActive: {
    borderRadius: 4,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: pink[500],
    backgroundColor: pink[500],
  },
  lastRow: {
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: pink[500]
  },
  lastRowActive: {
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    borderWidth: 1,
    borderStyle: 'solid',
    backgroundColor: pink[500],
    borderColor: pink[500]
  },

  incentiveHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-center',
    paddingTop: 8,
    paddingBottom: 8
  },
  incentiveIcon: {
    width: 20,
    height: 20
  },
  incentiveTitle: {
    marginLeft: 8,
    fontSize: 12,
    color: pink[500]
  },
  incentiveTitleActive: {
    marginLeft: 8,
    fontSize: 12,
    color: '#FFFFFF'
  },
  incentiveDescription: {
    paddingBottom: 8,
    fontSize: 12,
    textAlign: 'center',
  },
});

IncentivesField.propTypes = {
  incentives: PropTypes.array.isRequired,
  applicableIncentive: PropTypes.object,
  classes: PropTypes.object
};

function IncentivesField({
                           incentives,
                           applicableIncentive,
                           classes
                         }) {

  function renderRow(incentive, index, isActive) {
    let rowStyleClass = index === 0 ? classes.firstRow : index === incentives.length - 1 ? classes.lastRow : classes.row;

    if (incentives.length === 1) {
      rowStyleClass = classes.rowSingle;
    }

    if (isActive) {
      rowStyleClass = index === 0 ? classes.firstRowActive : index === incentives.length - 1 ? classes.lastRowActive : classes.rowActive;

      if (incentives.length === 1) {
        rowStyleClass = classes.rowSingleActive;
      }
    }

    let descriptionStyleClass = isActive ? classes.incentiveTitleActive : classes.incentiveTitle;

    return (
      <div className={rowStyleClass} key={incentive.id}>
        <div className={classes.rowContent}>
          {isActive &&
          <SvgIcon
            className={classes.incentiveIcon}
            htmlColor={'#FFFFFF'}>
            <path
              d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"/>
          </SvgIcon>
          }
          {!isActive &&
          <SvgIcon
            className={classes.incentiveIcon}
            htmlColor={pink[500]}>
            <path
              d="M12,15.39L8.24,17.66L9.23,13.38L5.91,10.5L10.29,10.13L12,6.09L13.71,10.13L18.09,10.5L14.77,13.38L15.76,17.66M22,9.24L14.81,8.63L12,2L9.19,8.63L2,9.24L7.45,13.97L5.82,21L12,17.27L18.18,21L16.54,13.97L22,9.24Z"/>
          </SvgIcon>
          }

          <Typography variant={'caption'} className={descriptionStyleClass}>
            {incentive.description}
          </Typography>
        </div>
      </div>
    );

  }

  return (
    <div className={classes.container}>
      <div className={classes.incentiveContainer}>
        {incentives.map((incentive, index) => (renderRow(incentive, index, applicableIncentive ? applicableIncentive.id === incentive.id : false)))}
      </div>
    </div>

  );
}

export default withStyles(styles)(IncentivesField);
